export default __webpack_public_path__ + "static/FReg-4x3-S_TalentShow-5aea841775047c727603dcbf7a85ba62.jpg";